import React, { useState, useEffect } from 'react';

// import SelectedCameraLifecycle from './SelectedCameraLifecycle';
import  './lifecycle.css';
import '../../styles/lifecycle.css';

import { Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { BeatLoader } from 'react-spinners';

import GradedBar from './cameraGradedBar/CameraGradedBar';
import CameraLifeExpectancyBar from './cameraGradedBar/CameraLifeExpectancyBar';

import { updateCameraLifecycle } from '../../redux/actions/updateCameraLifecycle';
import { canAccess } from '../../config';

// Import generic components
import Table from '../../generic_components/Table/Table';
import Modal from '../../generic_components/Modal/Modal';
import {useToast} from '../../generic_components/Toast/Toast';

const alertIcon = require('../../images/alertIcon.png');
const restartIcon = require('../../images/restart.png');




const CameraLifecycle = ({ cameras, selectedPeriod, serverName, selectedCameraLifeExpectancyDays, selectedCriticalDaysCamera, serverOperatingDays, userBusinessRole }) => {

    const [sortConfigCameraLifecycle, setSortConfigCameraLifecycle] = useState({ key: 'operatingDays', direction: 'ascending' });   

    const handleSortCameraLifecycle = (columnKey) => {
        let direction = 'ascending';
        if (sortConfigCameraLifecycle.key === columnKey && sortConfigCameraLifecycle.direction === 'ascending') {
        direction = 'descending';
        }
        setSortConfigCameraLifecycle({ key: columnKey, direction });
    };

    const renderSortIconCameraLifecycle = (columnKey) => {
        if (sortConfigCameraLifecycle.key === columnKey) {
        return sortConfigCameraLifecycle.direction === 'ascending' ? '▲' : '▼';
        }
        // Default to ascending arrow if not sorted yet
        return '▲';
    };

    // sort by all columns - alert data
    const sortedAllColumnsCameraLifecycle = [...cameras].sort((a, b) => {
        // if the key is operatingDays, we need to calculate the days passed
        if (sortConfigCameraLifecycle.key === 'operatingDays') {
            return sortConfigCameraLifecycle.direction === 'ascending' ? calculateDaysPassed(a.serverFirstCheckin) - calculateDaysPassed(b.serverFirstCheckin) : calculateDaysPassed(b.serverFirstCheckin) - calculateDaysPassed(a.serverFirstCheckin);
        }

        // if the key is daysSinceLastMaintenance, we need to calculate the days passed
        if (sortConfigCameraLifecycle.key === 'daysSinceLastMaintenance') {
            return sortConfigCameraLifecycle.direction === 'ascending' ? calculateDaysPassed(a.cameraLastMaintenance) - calculateDaysPassed(b.cameraLastMaintenance) : calculateDaysPassed(b.cameraLastMaintenance) - calculateDaysPassed(a.cameraLastMaintenance);
        }

        // if the key is remainingLifeExpectancy, we need to calculate the days passed
        if (sortConfigCameraLifecycle.key === 'remainingLifeExpectancy') {
            const remainingLifeExpectancyA = parseInt(selectedCameraLifeExpectancyDays) - calculateDaysPassed(a.cameraFirstCheckin);
            const remainingLifeExpectancyB = parseInt(selectedCameraLifeExpectancyDays) - calculateDaysPassed(b.cameraFirstCheckin);
            return sortConfigCameraLifecycle.direction === 'ascending' ? remainingLifeExpectancyA - remainingLifeExpectancyB : remainingLifeExpectancyB - remainingLifeExpectancyA;
        }

        if (a[sortConfigCameraLifecycle.key] < b[sortConfigCameraLifecycle.key]) {
        return sortConfigCameraLifecycle.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfigCameraLifecycle.key] > b[sortConfigCameraLifecycle.key]) {
        return sortConfigCameraLifecycle.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    function calculateDaysPassed(startDateUTC) {
        // Parse the start date as a UTC date
        const start = new Date(startDateUTC);
        // Get the current date in UTC
        const now = new Date();
        // Calculate the difference in milliseconds
        const diffInMilliseconds = now - start;
        // Convert the difference to days
        const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
        return diffInDays;
    }




    //                                   SelectedCameraLifecycle                   //
    const [showWarningModal, setShowWarningaModal] = useState(false);
    const [action, setAction] = useState(false);
    const [selectedCamera, setSelectedCamera] = useState('');
    const [localMaintUpdates, setLocalMaintUpdates] = useState({});

    const loadingCameraLifecycleUpdate = useSelector(state => state.loadingCameraLifecycleUpdate);
    const updateCameraLifecyclResponse = useSelector(state => state.updateCameraLifecycle);    

    const user = localStorage.getItem('email');

    const toast = useToast();

    const dispatch = useDispatch();
    
    function calculateDaysPassedLifecycleCam(startDateUTC) {
        // if startDateUTC is null or undefined, return serverOperatingDays
        if (!startDateUTC) {
          return serverOperatingDays;
        }

         // Parse the start date as a UTC date
         const start = new Date(startDateUTC);
        
        //  console.log(`Line 105 start time is ${start}`);
       
         // Get the current date in UTC
         const now = new Date();
         // Calculate the difference in milliseconds
         const diffInMilliseconds = now - start;
         // Convert the difference to days
         const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

         // if the difference is negative or 0, return serverOperatingDays
         if (diffInDays <= 0) {
           return serverOperatingDays;
         }
         return diffInDays;
    };

    const handleResetOperatingTime = (camera) => {
        setAction(true);
        const payload = { hwid: camera.hwid, camera_name:  camera.cameraName, camera_id: camera.cameraId, server_name: serverName, user: user };
        dispatch(updateCameraLifecycle(payload));
        closeWarningModal();
    };
    
    // // Warming Modal control
    const openWarningModal = (camera, cameraLastMaintenance) => {
        setSelectedCamera(camera);
        if (cameraLastMaintenance === 0) {
            const errorMsg = `Maintenance event of camera ${camera.cameraName} was already updated today.`;
            toast.error(errorMsg, {
                hideProgressBar: true,
                autoClose: 9000  
            });
            return;
        }
        setShowWarningaModal(true);
    };

    const closeWarningModal = () => {
        setShowWarningaModal(false);
    };

    useEffect(() => {
        if (action && updateCameraLifecyclResponse.code === 200) {
            
            const successMsg = "Operating days has been reset to zero.";
            toast.success(successMsg, {
                hideProgressBar: true,
                autoClose: 9000  
            });
            setAction(false);
            
            // Override the camera's lastMaintenance with 'now'
            setLocalMaintUpdates(prev => ({
                ...prev,
                [selectedCamera.cameraId]: new Date().toISOString()
            }));
        }

        if (action && updateCameraLifecyclResponse.code === 500) {
            
            const errorMsg = "Internal server error. Please try after some time.";
            toast.error(errorMsg, {
                hideProgressBar: true,
                autoClose: 9000
            });
            setAction(false);
        }     
    }, [updateCameraLifecyclResponse.code, toast, action, selectedCamera]);

    // Headers for lifecycle camera table
    const lifecycle_camera_columns = [
        {
            key: 'cameraName',
            label: 'Camera',
            onClick: () => handleSortCameraLifecycle('cameraName'),
            icon: renderSortIconCameraLifecycle('cameraName'),
        },
        {
            key: 'operatingDays',
            label: 'Operating Days',
            onClick: () => handleSortCameraLifecycle('operatingDays'),
            icon: renderSortIconCameraLifecycle('operatingDays'),
        },
        {
            key: 'daysSinceLastMaintenance',
            label: 'Total Days Since Last Maintenance',
            onClick: () => handleSortCameraLifecycle('daysSinceLastMaintenance'),
            icon: renderSortIconCameraLifecycle('daysSinceLastMaintenance'),
        },
        {
            key: 'remainingLifeExpectancy',
            label: 'Total Remaining Life Expectancy Days',
            onClick: () => handleSortCameraLifecycle('remainingLifeExpectancy'),
            icon: renderSortIconCameraLifecycle('remainingLifeExpectancy'),
        },
        {
            key: 'updateMaintenanceEvent',
            label: 'Update Maintenance Event',
        },
    ];

    // Data for lifecycle camera table
    const lifecycle_camera_data = cameras && sortedAllColumnsCameraLifecycle.map(camera => {        
        let barColor = 'green';
        // set color for expited cameras
        if (calculateDaysPassedLifecycleCam(camera.cameraFirstCheckin) > parseInt(selectedCameraLifeExpectancyDays)) {
            barColor = 'red';
        }

        // set color for critical cameras
        if (parseInt(selectedPeriod) - calculateDaysPassedLifecycleCam(camera.cameraFirstCheckin) < parseInt(selectedCriticalDaysCamera)
        && parseInt(selectedPeriod) - calculateDaysPassedLifecycleCam(camera.cameraFirstCheckin) > 0) {
            barColor = 'orange';
        }
        
        let cameraOperatingDays = calculateDaysPassedLifecycleCam(camera.cameraFirstCheckin);

        const cameraRemainingLifeExpectancyDays = selectedCameraLifeExpectancyDays - cameraOperatingDays;

        let effectiveLastMaintenance = localMaintUpdates[camera.cameraId] || camera.cameraLastMaintenance;
        let  cameraLastMaintenance = calculateDaysPassedLifecycleCam(effectiveLastMaintenance);
        if (!effectiveLastMaintenance) {
            cameraLastMaintenance = 'No maintenance performed';
        }

        // camera life expectancy bar
        const minCameraLifeExpectancy = 0;
        const maxCameraLifeExpectancy = selectedCameraLifeExpectancyDays;
        const currentCameraLifeExpectancy = cameraRemainingLifeExpectancyDays;

        return (
        {
            cameraName: camera.cameraName,
            operatingDays: (
                <div style={{ display: 'flex' }}>
                    <div style={{ width: '2em' }}>{cameraOperatingDays}</div>
                    <GradedBar barColor={barColor} />
                    {
                        calculateDaysPassedLifecycleCam(camera.cameraFirstCheckin) > selectedPeriod ?
                        <div>
                        <img src={alertIcon} alt='Alert' style={{ height: '1.6em', marginLeft: '0.5em' }}/>
                        </div> : null                
                    }
                </div>
            ),
            daysSinceLastMaintenance: (
                <div style={{ display: 'flex' }}>
                    <div style={{ width: cameraLastMaintenance === 'No maintenance performed' ? '13em' : '2em' }}>{ cameraLastMaintenance }</div>
                </div>
            ),
            remainingLifeExpectancy: (
                <div style={{ display: 'flex' }}>
                    <div style={{ width: '2em' }}>{ cameraRemainingLifeExpectancyDays }</div>
                    <CameraLifeExpectancyBar value={currentCameraLifeExpectancy} min={minCameraLifeExpectancy} max={maxCameraLifeExpectancy} />
                    {
                        calculateDaysPassedLifecycleCam(camera.cameraFirstCheckin) >= parseInt(selectedCameraLifeExpectancyDays) ?
                        <div>
                        <img src={alertIcon} alt='Alert' style={{ height: '1.6em', marginLeft: '0.5em' }}/>
                        </div> : null
                    }
                </div>           
            ),
            updateMaintenanceEvent: 
              !loadingCameraLifecycleUpdate ? 
            (
                <button className='reset-btn' onClick={() => openWarningModal(camera, cameraLastMaintenance)} disabled={!canAccess("asset-lifecycle-update-maintenance-camera", userBusinessRole)}>
                    <img src={restartIcon} alt='Reset' style={{ height: '1.5em' }}/>
                </button>
            ) :
            ( 
                <span>
                    <BeatLoader size={10} color="gray"/>
                </span>
            )
        })
    });


    return (
    <div className='table-container-lifecycle-camera table-container-lifecycle-camera-new' >
    <Table 
        columns = {lifecycle_camera_columns}
        data = {lifecycle_camera_data}
    />

        {/* Warning Modal*/}

        <Modal size='sm' show={showWarningModal} onHide={closeWarningModal} >
            <Modal.Header closeButton>
                <Modal.Title>Camera Maintenance</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div style={{ marginBottom:'1rem' }}>Are you sure you want to confirm maintenance event for camera <span style={{ color: 'orange' }}>{selectedCamera.cameraName}</span> ?</div>
                <div style={{ display: 'flex', justifyContent: 'space-between'}}>
                    <Button variant="danger" size='small' onClick={() => handleResetOperatingTime(selectedCamera)}>Yes</Button>
                    <Button variant="ghost" size='small' onClick={closeWarningModal}>Cancel</Button>
                </div>
            </Modal.Body>
        </Modal>
    </div>
  )
}

export default CameraLifecycle